class TreeParamDetails {
}
class TreeParamObject {
}
const activateTreeCounter = (params, treeElement) => {
    let comTreeInfos = {
        start: {
            year: 2016,
            month: 6,
            day: 21,
            trees: 61155000,
        },
        end: {
            year: 2020,
            month: 9,
            day: 30,
            trees: 100000000,
        },
    };
    if (params !== null && typeof params !== 'undefined' && typeof params != 'boolean') {
        comTreeInfos = params;
    }
    treeElement.classList.remove('numbers-loading');
    const timeStDebut = new Date(comTreeInfos.start.year, // ref année
    comTreeInfos.start.month - 1, //ref month
    comTreeInfos.start.day, 0, 0).getTime();
    const timeStFin = new Date(comTreeInfos.end.year, // ref année
    comTreeInfos.end.month - 1, //ref month
    comTreeInfos.end.day, 0, 0).getTime();
    const timeStGlobal = timeStFin - timeStDebut;
    const treesGlobal = comTreeInfos.end.trees - comTreeInfos.start.trees;
    window.setInterval(function () {
        const now = new Date().getTime();
        const pourcTime = (now - timeStDebut) / timeStGlobal;
        const number = pourcTime * treesGlobal;
        const treesPlanted = number + comTreeInfos.start.trees;
        const treesPlantedString = treesPlanted
            .toFixed()
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        const treeCounterHtmlElement = document.querySelector('.trees-counter__counter-box-numbers');
        if (treeCounterHtmlElement) {
            treeCounterHtmlElement.innerHTML = treesPlantedString;
        }
    }, 100);
};
export default (params, treeElement) => {
    activateTreeCounter(params, treeElement);
};
